import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import ErrorPage from "./ErrorPage.js";
import { mainContent } from "../../layout/Layout.css.js";

const RootErrorMsg: React.FC<RouteComponentProps> = ({ staticContext }) => {
    if (staticContext) {
        staticContext.statusCode = 500;
    }
    const title = "500";
    const message = "Oops, something bad happend. We are already fixing it...";
    return (
        <div className={mainContent}>
            <ErrorPage title={title} message={message} />
        </div>
    );
};

export default withRouter(RootErrorMsg);
